import { Tenant } from './tenant';
import { autoserialize, autoserializeAs } from 'cerialize';

export class RoleTenancy {
  @autoserialize
  roleId: number;

  @autoserializeAs(Tenant)
  tenant: Tenant;
}
